import AdvanceModal from './AdvanceModal';
export default AdvanceModal;
//# sourceMappingURL=index.js.map
